export default {"src":"/_next/static/media/dash-shiled.f6c25a43.svg","height":28,"width":24,"blurWidth":0,"blurHeight":0};